import React, { useContext } from "react";
import styled, { css } from "styled-components";
import { FaStar, FaRegStar, FaInfoCircle } from "react-icons/fa";
import { Link as A } from "raviger";
import { I18nContext } from 'i18n';

const MemberReports = ({ unavailable }) => {
  const { translate } = useContext(I18nContext);

  return (
    <ReportContainer>
      <Recent>
        <li>
          {!unavailable ? (
            <Link href="/comparison/peer">{translate('landing_peer_comparison')}</Link>
          ) : (
            <span>{translate('landing_peer_comparison')}</span>
          )}
        </li>
        <li>
          {!unavailable ? (
            <Link href="/comparison/criteria">{translate('landing_eligibility_criteria')}</Link>
          ) : (
            <span>{translate('landing_eligibility_criteria')}</span>
          )}
        </li>
      </Recent>
    </ReportContainer>
  );
};

const iconStyles = css`
  font-size: 1.2rem;
  margin: 0.3rem;
  margin-left: 0;
`;

const ReportContainer = styled.div`
  margin: 1rem;
`;

const Link = styled(A)`
  color: ${({ theme }) => theme.palette.grayscale[1]};
`;

const Recent = styled.ul`
  padding-left: 1rem;
  > li > span {
    color: ${({ theme }) => theme.palette.grayscale[2]};
  }
`;

const Star = styled(FaRegStar)`
  color: ${({ theme }) => theme.palette.grayscale[6]};
  ${iconStyles};
`;

const FilledStar = styled(FaStar)`
  color: ${({ theme }) => theme.palette.alert[1]};
  ${iconStyles};
`;

const InfoCircle = styled(FaInfoCircle)`
  font-size: 0.9rem;
`;

export default MemberReports;
